import * as Api from '@ViewModels';

/** Ids between two anchors in display order, inclusive; falls back to just the target when an anchor is gone. */
export function rangeBetween(orderedIds: string[], fromId: string | null, toId: string): string[] {
	const toIndex = orderedIds.indexOf(toId);
	const fromIndex = fromId ? orderedIds.indexOf(fromId) : -1;
	if (toIndex < 0) {
		return [];
	}
	if (fromIndex < 0) {
		return [toId];
	}
	const [start, end] = fromIndex < toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];
	return orderedIds.slice(start, end + 1);
}

/** After a bulk call, keep only the items the server could not update selected so the user can retry them. */
export function selectionAfterBulk(selected: Set<string>, result: Api.IBulkActionItemResult): Set<string> {
	const failedIds = new Set((result.failed ?? []).map(failure => failure.value).filter((id): id is string => !!id));
	return new Set([...selected].filter(id => failedIds.has(id)));
}
